import React from 'react';
import { motion } from 'framer-motion';
import { useGame } from '../../contexts/GameContext';
import { useLanguage } from '../../contexts/LanguageContext';
import TypeIcon from '../ui/TypeIcon';
import { TYPE_EFFECTS } from '../../constants/specialFish';

const GameControls = () => {
  const { state, changeType } = useGame();
  const { t } = useLanguage();

  const types = Object.entries(TYPE_EFFECTS).map(([id, config]) => ({
    id,
    ...config,
    name: t(`types.${id}.name`) || config.name
  }));

  return (
    <div className="type-selector">
      {types.map((type) => (
        <motion.button
          key={type.id}
          onClick={() => changeType(type.id)}
          className={`type-btn ${state.currentType === type.id ? 'active' : ''}`}
          style={{
            '--type-color': type.color,
            '--type-glow': type.glowColor
          }}
          whileTap={{ scale: 0.92 }}
        >
          <span className="type-icon">
            <TypeIcon type={type.id} size={24} />
          </span>
          <span className="type-label">{type.name}</span>
        </motion.button>
      ))}
    </div>
  );
};

export default GameControls;